import React, { Component } from "react";
import Select from "react-select";
import { BrowserHistory, Link } from "react-router-dom";
import whiteE from "./img/white-e.svg";
import "./App.scss";
import "./css/animate.css";

class Element extends Component {
  constructor(props) {
    super(props);

    console.log(this.props.location.state);
    this.state = this.props.location.state;
  }
  goBack() {
    this.props.history.goBack();
  }
  render() {
    return (
      <div>
        <div className="elementsContainer Element">
          <div className="left">
            <div
              className={
                "animated zoomIn elementLarge elementLargeBg" +
                this.state.selectedColor
              }
            >
              {this.state.selectedColor === "darkGray" ? (
                <span className="partnerP">P</span>
              ) : (
                <img src={whiteE} className="cornerLogo" />
              )}
              <h2>{this.state.selectedabbv}</h2>
              <h3>{this.state.selectedLabel}</h3>
            </div>
          </div>

          <div className="right">
            <h2>{this.state.selectedTitle}</h2>

            <div
              dangerouslySetInnerHTML={{ __html: this.state.selectedContent }}
            />
            <button className="backButton" onClick={this.goBack.bind(this)}>
              <i className="fa fa-chevron-left" aria-hidden="true" /> Back
            </button>
            {this.state.selectedUrl.length > 0 ? (
              <a
                href={this.state.selectedUrl}
                className="learnMore"
                rel
                nofollow
                target="_blank"
              >
                Learn More
              </a>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Element;
